import { Home, Calendar, CreditCard, Settings } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useMonitorRedirect } from "@/hooks/useMonitorRedirect";

export const Navigation = () => {
  const location = useLocation();
  const { isMonitor, isCheckingRole } = useMonitorRedirect();

  const isActive = (path: string) => location.pathname === path;

  const getPageName = (path: string) => {
    switch (path) {
      case "/":
        return "Home";
      case "/clases":
        return "Clases y reservas";
      case "/pagos":
        return "Pagos";
      case "/configuracion":
        return "Más";
      default:
        return "";
    }
  };

  // Don't render navigation for monitors - they only need the /monitor view
  if (isCheckingRole) {
    return null; // Don't show anything while checking role
  }

  if (isMonitor) {
    console.log("🚫 Navigation - hiding navigation for monitor user");
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 px-6 pb-6 z-50 pointer-events-none">
      <nav className="max-w-md mx-auto bg-black/60 backdrop-blur-lg rounded-full px-8 py-4 border border-white/10 pointer-events-auto">
        <div className="flex justify-around items-center gap-2">
          <Link
            to="/"
            className={`flex items-center justify-center space-x-2 transition-all duration-300 min-w-16 ${
              isActive("/")
                ? "text-primary scale-110"
                : "text-white/60 hover:text-white/80"
            }`}
          >
            {isActive("/") ? (
              <span className="text-sm font-medium animate-fade-in text-center">{getPageName("/")}</span>
            ) : (
              <Home className="w-5 h-5" />
            )}
          </Link>
          <Link
            to="/clases"
            className={`flex items-center justify-center space-x-2 transition-all duration-300 min-w-16 ${
              isActive("/clases")
                ? "text-primary scale-110"
                : "text-white/60 hover:text-white/80"
            }`}
          >
            {isActive("/clases") ? (
              <span className="text-sm font-medium animate-fade-in text-center">{getPageName("/clases")}</span>
            ) : (
              <Calendar className="w-5 h-5" />
            )}
          </Link>
          <Link
            to="/pagos"
            className={`flex items-center justify-center space-x-2 transition-all duration-300 min-w-16 ${
              isActive("/pagos")
                ? "text-primary scale-110"
                : "text-white/60 hover:text-white/80"
            }`}
          >
            {isActive("/pagos") ? (
              <span className="text-sm font-medium animate-fade-in text-center">{getPageName("/pagos")}</span>
            ) : (
              <CreditCard className="w-5 h-5" />
            )}
          </Link>
          <Link
            to="/configuracion"
            className={`flex items-center justify-center space-x-2 transition-all duration-300 min-w-16 ${
              isActive("/configuracion")
                ? "text-primary scale-110"
                : "text-white/60 hover:text-white/80"
            }`}
          >
            {isActive("/configuracion") ? (
              <span className="text-sm font-medium animate-fade-in text-center">{getPageName("/configuracion")}</span>
            ) : (
              <Settings className="w-5 h-5" />
            )}
          </Link>
        </div>
      </nav>
    </div>
  );
};
